import {RouteConfig} from "vue-router";
const PremiumView = () => import('../views/premium/PremiumView.vue');

let premium: RouteConfig[] = [
    {
        name: 'premium',
        path: '/premium',
        component: PremiumView,
        meta: {
            allowLoggedOut: true,
        },
    },
];

export default premium;